var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M51.4583 0.000198364L13.5417 0.000198364C6.06396 0.000198364 0 6.06416 0 13.5419L0 51.4585C0 58.9363 6.06396 65.0002 13.5417 65.0002H51.4583C58.9388 65.0002 65 58.9363 65 51.4585V13.5419C65 6.06416 58.9388 0.000198364 51.4583 0.000198364ZM21.6667 51.4585H13.5417V21.6669H21.6667V51.4585ZM17.6042 18.2327C14.9879 18.2327 12.8646 16.0931 12.8646 13.4552C12.8646 10.8173 14.9879 8.6777 17.6042 8.6777C20.2204 8.6777 22.3438 10.8173 22.3438 13.4552C22.3438 16.0931 20.2231 18.2327 17.6042 18.2327ZM54.1667 51.4585H46.0417V36.281C46.0417 27.1594 35.2083 27.85 35.2083 36.281V51.4585H27.0833V21.6669H35.2083V26.4471C38.9892 19.4433 54.1667 18.926 54.1667 33.1529V51.4585Z","fill":"white"}));
}

LinkedinInline.defaultProps = {"width":"65","height":"65","viewBox":"0 0 65 65","fill":"none"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
